__turbopack_context__.v({
  "blue": "Basic-module-scss-module__dDBXVW__blue",
  "cornflower": "Basic-module-scss-module__dDBXVW__cornflower",
  "ellipsis": "Basic-module-scss-module__dDBXVW__ellipsis",
  "gray": "Basic-module-scss-module__dDBXVW__gray",
  "green": "Basic-module-scss-module__dDBXVW__green",
  "magenta": "Basic-module-scss-module__dDBXVW__magenta",
  "orange": "Basic-module-scss-module__dDBXVW__orange",
  "pink": "Basic-module-scss-module__dDBXVW__pink",
  "red": "Basic-module-scss-module__dDBXVW__red",
  "span": "Basic-module-scss-module__dDBXVW__span",
  "violet": "Basic-module-scss-module__dDBXVW__violet",
});
